import { formatMessageWithParams } from "./LanguageHelper";

export function parseJsonToType<T>(jsonText: string): T {
  try {
    const parsedObject = JSON.parse(jsonText);
    return parsedObject as T;
  } catch (error) {
    throw new Error(
      formatMessageWithParams("cof.createnewobject.pastsettings.message.error.textformatnotvalid", {
        text: jsonText.slice(0, 30),
      })
    );
  }
}
